// extracted by mini-css-extract-plugin
export default {"item_poster":"ItemHomePoster_item_poster__j4eaV"};